import React from "react";
import {
  Box,
  MainTitle,
  RedirectSelectionInput,
  MainButton,
} from "app/components/common";
import AnimatedBox from "app/components/common/AnimatedBox";
import i18n from "@microdoing/shared/i18n";
import CompleteProfile from "../UserProfile/CompleteProfile";
import { SeparatorLine } from "app/components/common/SeparatorLine";
import KeyboardAwareScrollViewCustom from "../UserProfile/KeyboardAwareScrollViewCustom";
import { InputText } from "app/components/common/Inputs/Input";
import { useNavigation } from "@react-navigation/native";
import { useDispatch, useSelector } from "react-redux";
import { getUserClient } from "@microdoing/shared/services/signup/selectors";
import {
  getBio,
  getDisc,
  getFirstName,
  getJobDescription,
  getLastName,
  getMbti,
} from "@microdoing/shared/services/profileSettings/selectors";
import normalize from "app/utils/normalize";
import { isWeb } from "@microdoing/shared/utils/deviceDetectors";
import { changeUserInfo } from "@microdoing/shared/services/profileSettings/actions";
import theme from "app/Theme/Theme";

interface IProps {}

const Profile = ({}: IProps) => {
  const firstName = useSelector(getFirstName);
  const lastName = useSelector(getLastName);
  const jobDescription = useSelector(getJobDescription);
  const mbti = useSelector(getMbti);
  const disc = useSelector(getDisc);
  const bio = useSelector(getBio);
  const { hasCustomOnboarding } = useSelector(getUserClient);

  const dispatch = useDispatch();
  const navigation = useNavigation();

  const getProfileCompleteness = () => {
    let total = 1;
    const coef = hasCustomOnboarding ? total / 4 : total / 5;
    if (!firstName) {
      total -= coef;
    }
    if (!lastName) {
      total -= coef;
    }
    if (!jobDescription) {
      total -= coef;
    }

    if (!hasCustomOnboarding) {
      if (!mbti) {
        total -= coef;
      }
    }
    if (!bio) {
      total -= coef;
    }
    return total;
  };

  const onChangeLastName = (lastName: string) => {
    dispatch(changeUserInfo({ lastName }));
  };

  const onChangeFirstName = (firstName: string) => {
    dispatch(changeUserInfo({ firstName }));
  };

  const onChangeBio = (bio: string) => {
    if (bio.length <= 280) {
      dispatch(changeUserInfo({ bio }));
    }
  };

  const onChangeJobDescription = (jobDescription: string) => {
    dispatch(changeUserInfo({ jobDescription }));
  };

  const changeMbtiChoice = () => {
    navigation.navigate("Mbti");
  };

  const changeDiscChoice = () => {
    navigation.navigate("Disc");
  };

  return (
    <KeyboardAwareScrollViewCustom
      testID="settings-scrollView"
      contentContainerStyle={styles.mainView}
    >
      <Box width="100%" paddingVertical="s">
        <InputText
          placeholderText={i18n.t("firstName")}
          onPress={onChangeFirstName}
          selectedText={firstName}
          placeholderTextInput={i18n.t("settings-firstName-placeholder")}
          styleTextInput={styles.input}
        />
      </Box>
      <Box width="100%" paddingVertical="s">
        <InputText
          placeholderText={i18n.t("lastName")}
          onPress={onChangeLastName}
          selectedText={lastName}
          placeholderTextInput={i18n.t("settings-lastName-placeholder")}
          styleTextInput={styles.input}
        />
      </Box>
      <Box width="100%" paddingVertical="s">
        <InputText
          placeholderText={i18n.t("jobDescription")}
          onPress={onChangeJobDescription}
          selectedText={jobDescription}
          placeholderTextInput={i18n.t("add-job-you-hold")}
          styleTextInput={styles.input}
        />
      </Box>
      <Box width="100%" paddingVertical="s">
        <InputText
          placeholderText={i18n.t("description")}
          onPress={onChangeBio}
          selectedText={bio}
          placeholderTextInput={i18n.t("add-description")}
          styleTextInput={{ minHeight: isWeb ? normalize(70) : 0 }}
        />
      </Box>
      <Box paddingTop="sm" paddingHorizontal="xm" width="100%">
        <RedirectSelectionInput
          testID="mbti"
          onPress={changeMbtiChoice}
          placeholderText={i18n.t("mbti-score")}
          selectedText={mbti}
        />
      </Box>
      <Box paddingHorizontal="xm" width="100%" marginTop="s">
        <RedirectSelectionInput
          testID="disc"
          onPress={changeDiscChoice}
          placeholderText={i18n.t("disc-score")}
          selectedText={disc ? i18n.t(disc) : ""}
        />
      </Box>
    </KeyboardAwareScrollViewCustom>
  );
};

const styles = {
  mainBox: {
    alignSelf: "center",
    width: "100%",
    paddingHorizontal: 0,
    marginBottom: 15,
  },
  input: {
    paddingTop: 0,
    marginBottom: theme.spacing.sm,
  },
  completeProfile: {
    marginBottom: 20,
  },
  mainView: {
    flexGrow: 1,
    justifyContent: "flex-start",
    alignItems: "flex-start",
    backgroundColor: "white",
    width: "100%",
  },
};

export default Profile;
